export const LOCAL_KEYS = {
  session_user: 'ba_session_user',
  client_language: 'i18nextLng',
  user_persistence: 'ba_user_persistence',
  user_image: 'ba_user_image',
  user_image_id: 'ba_user_image_id',
  survey_answered: 'ba_survey',
  survey_answered2: 'ba_survey2',
  survey_answered3: 'ba_survey3',
  survey_answered4: 'ba_survey4',
  content_tree: 'ba_tree',
  new_content1: 'new_content1',
  seen_content: 'seen_content',
  onboarding_skipped: 'bioatlas_onboarding_skipped',
  last_viewed_content: 'ba_last_viewed_content',
  weekly_top_contents: 'ba_weekly_top_contents',
  next_releases: 'ba_next_releases',
  next_releases_notify: 'ba_next_releases_notify',
  temp_collections: 'ba_temp_collections'
}

export const SESSION_KEYS = {
  token_ttl: 'ba_token_ttl',
  navigation_data: 'ba_nav_data',
  client_alert: 'ba_swal_client',
  snowplow_uuid: 'ba_snowplow',
  demo_popup_was_closed: 'ba_demo_popup_was_closed',
  unity_user_agent: 'ba_unityUA',
  history: 'ba_history'
}

export const clearStorage = () => {
  localStorage.removeItem(LOCAL_KEYS.session_user)
  localStorage.removeItem(LOCAL_KEYS.client_language)
  localStorage.removeItem(LOCAL_KEYS.user_persistence)
  localStorage.removeItem(LOCAL_KEYS.user_image)
  localStorage.removeItem(LOCAL_KEYS.user_image_id)
  localStorage.removeItem(LOCAL_KEYS.content_tree)
  localStorage.removeItem(LOCAL_KEYS.seen_content)
  localStorage.removeItem(LOCAL_KEYS.last_viewed_content)
  localStorage.removeItem(LOCAL_KEYS.weekly_top_contents)

  sessionStorage.removeItem(SESSION_KEYS.token_ttl)
  sessionStorage.removeItem(SESSION_KEYS.navigation_data)
  sessionStorage.removeItem(SESSION_KEYS.client_alert)
  sessionStorage.removeItem(SESSION_KEYS.snowplow_uuid)
  sessionStorage.removeItem(SESSION_KEYS.unity_user_agent)
}

export const setWithExpiry = (
  key: string,
  value: string | number | object,
  ttl: number
) => {
  const now = new Date()
  const item = { value: value, expiry: now.getTime() + ttl }
  localStorage.setItem(key, JSON.stringify(item))
}

export const setWithFixedExpiry = (
  key: string,
  value: string | number | object,
  expiration: number
) => {
  const item = { value: value, expiry: expiration }
  localStorage.setItem(key, JSON.stringify(item))
}

export const getWithExpiry = <T>(key: string): T | null => {
  const itemStr = localStorage.getItem(key)
  if (!itemStr) return null

  const item = JSON.parse(itemStr)
  const now = new Date()
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key)
    return null
  }

  return item.value
}

export const getParsed = <T>(
  storage: Storage,
  key: string,
  defaultValue: T | null = null
): T | null => {
  const str = storage.getItem(key)
  if (str) {
    return JSON.parse(str)
  }

  return defaultValue
}

export const setParsed = (
  storage: Storage,
  key: string,
  value: string | number | object
) => {
  storage.setItem(key, JSON.stringify(value))
}

export const removeByKey = (storage: Storage, key: string) => {
  storage.removeItem(key)
}
